import { PlusOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout'
import { useSuspenseQuery } from '@apollo/client'
import { FetchGoalDimensionsDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath, SuspenseWithLoading, useCanForFeatures } from '@salescore/client-common'
import { GoalDimensionsTable, UpsertGoalDimensionForm } from '@salescore/client-feature-setting'
// eslint-disable-next-line sonarjs/deprecation
import { useModal } from '@salescore/frontend-common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Alert, Button, Modal } from 'antd'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const Page = (): ReactElement => {
  const navigate = useNavigate()
  const { organizationId } = Route.useParams()
  // eslint-disable-next-line sonarjs/deprecation
  const createModal = useModal()
  const { t } = useTranslation()
  const { data, refetch: invalidate } = useSuspenseQuery(FetchGoalDimensionsDocument, {
    variables: { organizationId: getOrganizationIdFromPath() },
  })
  const { canManageGoal } = useCanForFeatures()

  if (!canManageGoal) {
    return (
      <div>
        <Alert type="warning" message={t(`権限がありません`)} />
      </div>
    )
  }

  return (
    <PageHeader
      onBack={() => {
        void navigate({ to: '/o/$organizationId/v2/settings/goal_configs', params: { organizationId } })
      }}
      title={t(`目標軸一覧`)}
      extra={[
        <Button
          key="button-back-to-goals-setting"
          onClick={() => {
            void navigate({ to: '/o/$organizationId/v2/settings/goal_configs', params: { organizationId } })
          }}
        >
          {t(`目標設定へ戻る`)}
        </Button>,
        <Button key="button-create" icon={<PlusOutlined />} type="primary" onClick={createModal.showModal}>
          {t(`作成`)}
        </Button>,
      ]}
    >
      <GoalDimensionsTable
        goalDimensions={data.goalDimensions}
        withDimensionGroup
        refresh={() => {
          void invalidate()
        }}
      />
      <Modal
        key="createModal"
        open={createModal.isModalVisible}
        onCancel={createModal.hideModal}
        width={'70%'}
        cancelText={t(`閉じる`)}
        okButtonProps={{ style: { display: 'none' } }}
        style={{ top: '3%' }}
        destroyOnHidden
      >
        <SuspenseWithLoading>
          <UpsertGoalDimensionForm
            withDimensionGroup
            onAfterFinish={() => {
              void invalidate()
              createModal.hideModal()
            }}
          />
        </SuspenseWithLoading>
      </Modal>
    </PageHeader>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/goal_dimensions')({
  component: Page,
})
